var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImagetypeActiveHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Image_type_Active_-_Hover_",
    "data-name": "Image type | Active - Hover ",
    d: "M9.545,5A4.55,4.55,0,0,0,5,9.545v8.6l4.148-4.013a2.369,2.369,0,0,1,3.216,0l3.15,3.048,1.27-1.23a2.3,2.3,0,0,1,1.6-.65h0A2.3,2.3,0,0,1,20,15.954l4.983,4.82c.008-.106.017-.212.017-.32V9.545A4.55,4.55,0,0,0,20.455,5Zm9.091,4.848a1.515,1.515,0,1,1-1.515,1.515A1.515,1.515,0,0,1,18.636,9.848Zm-7.881,5.459a.5.5,0,0,0-.344.134l-5.4,5.225a4.55,4.55,0,0,0,2.784,3.982l6.411-6.2L11.1,15.442A.5.5,0,0,0,10.755,15.308Zm7.637,1.813a.491.491,0,0,0-.343.138l-8,7.74H20.455a4.544,4.544,0,0,0,3.931-2.274l-5.65-5.466A.49.49,0,0,0,18.393,17.121Z",
    transform: "translate(-5 -5)",
    fill: "#0f7bff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagetypeActiveHover);
export default __webpack_public_path__ + "static/media/Image type  Active - Hover.bedbd6aa.svg";
export { ForwardRef as ReactComponent };